import FormattedMessage from 'I18n/components/FormattedMessage';
import { Big } from 'foundations-components/transitional/components/Big';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { Small } from 'foundations-components/transitional/components/Small';
import { Tile } from 'foundations-components/transitional/components/Tile';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { useContext } from 'react';
import { AppContext } from '../../contexts/app/context';
import { CompaniesIcon } from 'foundations-assets/icons/components/CompaniesIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AccountListRow({
  onClick,
  accountName,
  domain,
  portalId
}) {
  const {
    appName
  } = useContext(AppContext);
  return /*#__PURE__*/_jsx(Clickable, {
    onClick: onClick,
    "data-test-id": `${appName}-accounts-item`,
    children: /*#__PURE__*/_jsx(Tile, {
      compact: true,
      marginBlockEnd: "400",
      padding: "400",
      children: /*#__PURE__*/_jsxs(MediaObject, {
        align: "center",
        itemLeft: /*#__PURE__*/_jsx(IconCircle, {
          color: "fill-tertiary-pressed",
          backgroundColor: "fill-primary-disabled",
          borderWidth: "0",
          size: "400",
          icon: CompaniesIcon
        }),
        children: [(accountName || domain) && /*#__PURE__*/_jsx(TruncateString, {
          children: /*#__PURE__*/_jsx(Big, {
            weight: "bold",
            children: accountName || domain
          })
        }), /*#__PURE__*/_jsx(TruncateString, {
          children: /*#__PURE__*/_jsxs(Small, {
            use: "help",
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: "hubspotAccount.id"
            }), ' ', /*#__PURE__*/_jsx("span", {
              children: portalId
            })]
          })
        })]
      })
    })
  });
}
export default AccountListRow;